import {
  postData,
  postFormData,
  createFormData,
  postRequest,
} from 'src/services/RestApi';

export const getStatusMapper = (result) => {
  if(result.status === 0){
    result.statusName = 'Đã bị khóa';
    result.statusVerify = 'Vô hiệu tài khoản';
  }else if(result.status === 3){
    result.statusName = 'Ngưng hoạt động';
    result.statusVerify = 'Xóa tài khoản';
  }else{
    result.statusName = 'Hoạt động';
    result.statusVerify = 'Khóa tài khoản';
  }
  return result;
};

export const apiCreate = async (values) => {
  const { formData, queryData } = requestParams(values);

  return await postFormData('api/account/create', formData, queryData);
};

export const apiUpdate = async (payload) => {
  const queryData = requestParams(payload, true);
  return await postData('api/account/edit', queryData);
};

export const apiDetele = async (payload) => {
  return await postData('api/account/delete', {accountCode: payload.code});
};

export const apiBlockAccount = async (payload) => {
  return await postData('api/account/block', {accountId: payload.id});
};

export const apiUnlockAccount = async (payload) => {
  return await postData('api/account/unlock', {accountId: payload.id});
};

export const apiChangeInfo = async (payload) => {
  const { formData, queryData } = requestParams(payload, true);
  return await postRequest('api/account/change/info', formData, queryData);
};

export const apiChangeNote = async (payload) => {
  const queryData = {
    accountId: payload.accountId,
    note: payload.note
  }
  return await postRequest('api/account/change/note', {}, queryData);
};

function requestParams(values, isUpdate = false) {
  const queryData = {};
  if (isUpdate) {
    queryData.accountId = values.id;
    queryData.accountCode = values.code;
  }

  if (values.nameField) {
    queryData.name = values.nameField;
  }
  if (values.phoneField) {
    queryData.phone = values.phoneField;
  }
  if (values.cardIdField) {
    queryData.cardId = values.cardIdField;
  }
  if (values.birthdayField) {
    queryData.birthday = values.birthdayField;
  }
  if (values.emailField) {
    queryData.email = values.emailField;
  }
  if (values.addressField) {
    queryData.address = values.addressField;
  }
  if (values.note) {
    queryData.note = values.note;
  }

  const formData = createFormData(values);
  return { formData, queryData };
}

